class BaseTabs {
    constructor(activeTab, onTabChange) {
        this.activeTab = activeTab
        this.onTabChange = onTabChange
        this.init()
    }

    init() {
        const tabs = document.querySelectorAll('.base-tabs-header')
        const tabsContents = document.querySelectorAll('.base-tabs-content')
        tabs.forEach((tab) => {
            tab.classList.remove('base-tabs-header--active')
        })
        tabsContents.forEach((item) => {
            item.classList.add('base-tabs-content--hidden')
        })
        document.querySelector(`.base-tabs-header[data-tab="${this.activeTab}"]`).classList.add('base-tabs-header--active')
        document.querySelector(`.base-tabs-content[data-tab="${this.activeTab}"]`).classList.remove('base-tabs-content--hidden')
        tabs.forEach((tab) => {
            const tabData = tab.dataset.tab
            tab.addEventListener('click', () => {
                tabs.forEach((item) => {
                    item.classList.remove('base-tabs-header--active')
                })
                tabsContents.forEach((item) => {
                    item.classList.add('base-tabs-content--hidden')
                })
                tab.classList.add('base-tabs-header--active')
                document.querySelector(`.base-tabs-content[data-tab="${tabData}"]`).classList.remove('base-tabs-content--hidden')
                this.onTabChange(tabData)
            })
        })
    }

    onTabChange(tab) {}
}

export default BaseTabs
